import {
  FormFieldBlueprint,
  createFormField,
} from '@backstage/plugin-scaffolder-react/alpha';
import { makeFieldSchema } from '@backstage/plugin-scaffolder-react';
import { RdapFormSectionField } from '../fields/RdapFormSection';
import {
  rdapFormSectionUiOptionsSchema,
  rdapFormSectionValueSchema,
} from '../schemas/rdapFormSectionSchema';

export const rdapFormSectionFieldExtension: any = FormFieldBlueprint.make({
  name: 'rdap-form-section',
  params: {
    field: async () =>
      createFormField({
        name: 'RdapFormSection',
        component: RdapFormSectionField,
        schema: makeFieldSchema({
          output: () => rdapFormSectionValueSchema,
          uiOptions: () => rdapFormSectionUiOptionsSchema,
        }),
      }),
  },
});
